'use client';

import ReactDOM from 'react-dom';

export default function PublicationPreconnect() {
  // Preconnect к CDN с картинками объявлений
  ReactDOM.preconnect('https://images-20f98.kxcdn.com', {
    crossOrigin: 'anonymous'
  });

  // DNS-prefetch для того же хоста
  ReactDOM.prefetchDNS('https://images-20f98.kxcdn.com');

  return null;
}
